import React from "react";

function Education({ education }) {
  return (
    <section className="education-section container px-0 my-5">
      <div className="row">
        <div className="col-xs-12 col-md-4 order-1">
          <h2>Education</h2>
        </div>
        <div className="col-xs-12 col-md-8 order-2">
          {education.map((school, index) => (
            <div key={index} className="school mb-4">
              <h3 className="h4">{school.degree}</h3>
              <p className="institution-location mb-0">
                {school.institution} | {school.location}
              </p>
              <p className="duration">{school.duration}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Education;
